import { useEffect, useRef } from 'react';

/**
 * This custom hook is used to hold a certain value during the next update cycle.
 *
 * @param value T
 */
export default function usePrevious<T>(value: T) {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
